// See README.md for more info about field configuration

import moment from 'moment'
import _get from 'lodash/get'

import { FIELD_TYPE, REFDATA_MAP} from '@/constants'
import { dropDownSelect } from '@/applicationDefinition/droplistData/helper'

import { ETHINIC } from './droplistData/ethinic'
import { MARITAL } from './droplistData/maritalStatus'
import { getFirstName, getLabelName, concatNone } from './helper'

export default [
  {
    label: 'Personal Information',
    description:
      'Please provide accurate details of the client applying. This information is used to help processing application.',
    type: FIELD_TYPE.HEADING
  },
  {
    apiKey: 'client.email',
    label: 'Contact email',
    placeHolder: 'Enter email address',    
    disabled: true,
    type: FIELD_TYPE.EMAIL,   
    maxLength: 132
  },
  {
    apiKey: 'client.firstName',
    label: "Legal First Name",
    placeHolder: 'Enter first name',
    required: true,
    type: FIELD_TYPE.NAME,
    maxLength: 100
  },
  {
    apiKey: 'client.lastName',
    label : 'Legal Last Name',
    placeHolder: 'Enter Last name',
    required: true,
    type: FIELD_TYPE.NAME,
    maxLength: 100,
  },
  {
    apiKey: 'client.previousName',
    label:' Previous Name(s)',
    placeHolder: 'Enter Previous name(s)',
    required: false,
    type: FIELD_TYPE.NAME,
    maxLength: 100
  },  
  {
    apiKey: 'client.dateOfBirth',
    label:"Birth Date",
    required: true,
    type: FIELD_TYPE.DATE,
    pastYears: 150,
    futureYears: 0,
    validation(value) {
      if (moment(value) > moment()) {
        return 'Cannot be a future date'
      }

      if (moment() < moment(value).add(7, 'd')) {
        return 'client must be at least 1 week old'
      }
    }
  },
  {
    apiKey: 'client.ethinicity.ethinics',
    label :'Ethnic/Racial Demographic (Select All that apply)',    
    required: true,
    type: FIELD_TYPE.CHECKBOX_GROUP,
    options() {
      return concatNone(ETHINIC)
    }
    
  },
  {
    apiKey: 'client.ethinicity.otherEthinicity',
    label: 'Other Ethnicity details',
    placeHolder: 'Enter other ethnicity details',
    type: FIELD_TYPE.TEXTAREA,
    maxCharacter: 300,
    required: true,
    maxRows: 2,
    visible(application) {
      const ethinicity = application.client.ethinicity.ethinics
      if (ethinicity && ethinicity.find(item => item === 'OtherEthinicity')) {
        return ethinicity.find(item => item === 'OtherEthinicity').length > 0
      }
    }
  },
  {
    apiKey: 'client.maritalStatus',
    label: 'Marital Status',
    type: FIELD_TYPE.DROPDOWN,
    options: MARITAL,
    required: true
  }
  
]
